import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore
} from 'redux';

import thunk from 'redux-thunk';

import {augmentMixpanel, remimi} from './middleware/mixpanel';
import {clearAlerts} from './middleware/alertClearer';
import {TEST_RESET} from '../actions/ActionTypes';
import * as reducers from '../reducers';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  if (action.type === TEST_RESET) {
    state = undefined; // eslint-disable-line no-param-reassign
  }

  return appReducer(state, action);
};

export default createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk),
  applyMiddleware(clearAlerts),
  applyMiddleware(augmentMixpanel),
  applyMiddleware(remimi)
));
